import styled from "styled-components";

import { Tab as TabMui } from "@libraries/mui";

const Tab = styled(TabMui)`
  color: white !important;
  text-transform: none !important;
  padding: 0px 5px !important;
  min-height: 35px !important;
  max-height: 35px !important;
  min-width: 125px !important;
  max-width: 125px !important;
  border-radius: 10px !important;
  font-size: 12px !important;

  :hover {
    background-color: #f5f5f5;
  }
`;

export { Tab };
